import { render } from "./DefaultAvatar.vue?vue&type=template&id=996f343a"
import script from "./DefaultAvatar.vue?vue&type=script&lang=js"
export * from "./DefaultAvatar.vue?vue&type=script&lang=js"
script.render = render

export default script